export const environment = 'prd'

export const tradingApi = 'https://api.rhino.fi'

export const multiCallDoNotAggregate = ['BINANCE']

export const LEGACY_RHINO_CLAIMS = {
  ETHEREUM: [
    1000, 1001, 1003, 1004, 1007, 1008, 1009, 1010, 1012, 1014, 1015, 1016, 1018, 1020, 1021, 1022, 1025, 1030, 1032,
    1035, 1036, 1042, 1044, 1045, 1046, 1047, 1051, 1052, 1053, 1054, 1059, 1060, 1061, 1062, 1063, 1064, 1066, 1067,
    1068, 1069, 1070, 1071, 1072, 1073, 1074, 1076, 1077, 1078, 1079, 1080,
    // disabled campaigns: CUSDT, MPL, DOGE, LTC, ETHBTCMOMENTUM, ETHBTCTREND
    // 1017,1048,1019,1043,1026,1027,
  ],
}

export const LEGACY_CROSS_CHAIN_SWAP_CONTRACTS = [
  { chain: 'ARBITRUM_MAINNET', contractAddress: '0xca8e436347a46502e353cc36b58fe3bb9214d7fd' },
  { chain: 'BINANCE_MAINNET', contractAddress: '0xca8e436347a46502e353cc36b58fe3bb9214d7fd' },
  { chain: 'POLYGON_MAINNET', contractAddress: '0xda7EeB4049dA84596937127855B50271ad1687E7' },
]
